var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-container",
      style: { height: _vm.maxHeight - 100 + "px" }
    },
    [
      _c("multi-selection-toolbar", {
        attrs: {
          layer: _vm.layer,
          "can-modify-objects": _vm.canModifyObjects,
          "can-generate-request": _vm.canGenerateRequest,
          "closure-delete": _vm.closureDelete
        },
        on: {
          closeDialogDeleteClosure: function($event) {
            _vm.closureDelete.dialogOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("multi-selection-table", {
        attrs: {
          layer: _vm.layer,
          "can-highlight-objects": _vm.canHighlightObjects
        },
        on: {
          loadingObjects: function($event) {
            return _vm.$emit("loadingObjects", $event)
          },
          closureDelete: function($event) {
            _vm.closureDelete = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b64cfcc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b64cfcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/MultiSelectionForm/MultiSelectionTab.vue
// module id = null
// module chunks = 